import { useState } from "react";


export const useSelectAccountsStates = () => {
  const [isActiveRegisterButton, setIsActiveRegisterButton] = useState(false);

  return {
    isActiveRegisterButton,
    setIsActiveRegisterButton,
  };
};
